import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["timeField", "mealTypeField"]

  connect() {
    // Auto-fill meal type on page load based on current time
    this.updateMealType()
  }

  updateMealType() {
    const timeValue = this.timeFieldTarget.value
    if (!timeValue) return

    // Parse the datetime-local value
    const selectedDate = new Date(timeValue)
    const hour = selectedDate.getHours()

    // Determine meal type based on hour
    let mealType = ''

    if (hour >= 5 && hour < 11) {
      mealType = 'breakfast'  // Bữa sáng: 5am - 10:59am
    } else if (hour >= 11 && hour < 16) {
      mealType = 'lunch'      // Bữa trưa: 11am - 3:59pm
    } else if (hour >= 16 && hour < 21) {
      mealType = 'dinner'     // Bữa tối: 4pm - 8:59pm
    } else {
      mealType = 'snack'      // Snack: 9pm - 4:59am
    }

    // Only auto-fill if meal type is not already selected
    if (!this.mealTypeFieldTarget.value || this.mealTypeFieldTarget.value === '') {
      this.mealTypeFieldTarget.value = mealType
    } else {
      // Update meal type when time changes (always update)
      this.mealTypeFieldTarget.value = mealType
    }
  }
}
